import { createApi } from "@reduxjs/toolkit/query/react";
import { MetricFilterItem } from "../../analytics/interfaces/documentSetMetrics";
import { setMetricsMap } from "./appSlice";
import {
  parseReduxQueryError,
  customBaseQuery,
} from "../../common/reduxQuery/helpers";
import { OverviewConfig } from "../../documentSet/interfaces/overview";

export const appApi = createApi({
  reducerPath: "appApi",
  baseQuery: customBaseQuery(),
  endpoints: (build) => ({
    getMetricFilterItems: build.query<Array<MetricFilterItem>, Array<string>>({
      query: (inputIds) => ({
        url: `api/v1/metrics/${inputIds.join(",")}`,
        method: "GET",
      }),
      async onQueryStarted(args, { dispatch, queryFulfilled }) {
        try {
          const { data } = await queryFulfilled;
          dispatch(setMetricsMap(data));
        } catch (err) {
          console.error(
            `An error occurred while retrieving the metric filter items: ${parseReduxQueryError(
              err,
            )}`,
          );
        }
      },
    }),
    getAppConfig: build.query<OverviewConfig, Array<string>>({
      query: (inputIds) => ({
        url: `api/v1/app-config/${inputIds.join(",")}`,
        method: "GET",
      }),
    }),
  }),
});

export const { useGetMetricFilterItemsQuery, useLazyGetAppConfigQuery } =
  appApi;
